export const FILTER = 'FILTER';
export const GET_DISPLAY_PROPERTIES = 'GET_DISPLAY_PROPERTIES';
export const REQUEST_WAITLIST = 'REQUEST_WAITLIST';



// WEBPACK FOOTER //
// ./src/actions/waitlist/types.js